import type { ReactNode } from 'react';
import { useOutletContext } from 'react-router-dom';

import type { OrderStepDefinition, OrderUrlState } from './steps';

/**
 * What OrderLayout hands down to each step page.
 *
 * Note what is NOT here: any draft-order data. The context carries the derived
 * view of the URL (ids, current step, stepper element) and nothing that would be
 * lost on reload — see the persistence note in ./steps.ts.
 */
export interface OrderStepContext {
  urlState: OrderUrlState;
  step: OrderStepDefinition;
  currentIndex: number;
  stepper: ReactNode;
}

/** Typed accessor for that context. Step pages call this, never useOutletContext. */
export function useOrderStep(): OrderStepContext {
  return useOutletContext<OrderStepContext>();
}
